import { create } from 'zustand';
import { useChatStore } from '../components/Pleri/store/chatStore';

interface LayoutState {
  isMiniMode: boolean;
  setMiniMode: (isMiniMode: boolean) => void;
  toggleMiniMode: () => void;
  minimizeToMiniMode: () => void;
}

export const useLayoutStore = create<LayoutState>((set) => ({
  isMiniMode: true,
  setMiniMode: (isMiniMode) => set({ isMiniMode }),
  toggleMiniMode: () => set((state) => ({ isMiniMode: !state.isMiniMode })),
  minimizeToMiniMode: () => {
    // Single source of truth: when minimizing, also close focused view
    const chatStore = useChatStore.getState();
    const activeConversationId = chatStore.activeConversationId;

    if (activeConversationId) {
      // Close focused view if open
      const conversation = chatStore.conversations[activeConversationId];
      if (conversation?.focusedViewOpen) {
        chatStore.setFocusedViewOpen(activeConversationId, false);
        chatStore.setFocusedViewContent(null);
      }
    }

    // Switch to mini mode
    set({ isMiniMode: true });
  },
}));
